import React from "react";
export const Item = ({ label, children }) => {
    return (
        <span>
            {label}
            {children}
        </span>
    );
};
